import { h } from "preact";
import Required from "./Required";
import Description from "./Description";
import DayPickerInput from "react-day-picker/DayPickerInput";
import "react-day-picker/lib/style.css";
import { css } from "emotion";

const DateField = ({
  input,
  label,
  description,
  inputType,
  required,
  type,
  style,
  meta: { touched, error, warning }
}) => {
  const dateStyle = css({
    width: "100%",
    input: {
      width: "100%"
    },
    ".DayPickerInput": {
      width: "100%"
    }
  });

  const handleDayChange = day => {
    let newDate = new Date(day);
    if (newDate.getFullYear() > 3000) {
      newDate.setFullYear(newDate.getFullYear() - 200000);
    }
    newDate.setHours(0, 0, 0, 0);
    const value = `${newDate.getFullYear()}-${newDate.getMonth() +
      1}-${newDate.getDate()}`;
    input.onChange(value);
  };
  inputType = inputType ? inputType : type;
  let value = "";
  if (input.value) {
    value = new Date(input.value);
    if (value.getFullYear() > 3000) {
      value.setFullYear(value.getFullYear() - 200000);
    }
    value.setHours(0, 0, 0, 0);
    value = `${value.getDate()}/${value.getMonth() + 1}/${value.getFullYear()}`;
  }

  return (
    <div
      class={touched && error ? "form-group has-error" : "form-group"}
      style={style}
    >
      <div className={dateStyle}>
        {label ? (
          <label for={input.name} class="form-label">
            {label}
            <Required required={required} />
          </label>
        ) : (
          ""
        )}
        <Description description={description} />
        <DayPickerInput
          placeholder="DD/MM/YYYY"
          value={value}
          onDayChange={day => handleDayChange(day)}
          component={props => (
            <input
              class="form-input"
              {...props}
              onBlur={input.onBlur}
              id={input.name}
              aria-required={required ? "true" : "false"}
              aria-describedby={`${input.name}Error`}
            />
          )}
        />
        {touched && error && (
          <p class="form-input-hint" id={`${input.name}Error`}>
            {error}
          </p>
        )}
      </div>
    </div>
  );
};

export default DateField;



// WEBPACK FOOTER //
// ./components/fields/DateField.js